import { CSSProperties, FC } from 'react';

// Wareozo navbar logo (public/logos SVG, 650x200 artboard with the mark + wordmark
// occupying x 77-529, y 54-149). The wrapper crops the blank artboard margin so the
// navbar height follows the visible logo, not the artboard.
const SRC = '/logos/Icon_frame_wareozo_White_copy_650x200.svg';
const ART_W = 650, ART_H = 200;
const BOX = { x: 77, y: 54, w: 452, h: 95 };
// The wordmark starts just right of the mark; used to whiten only the text on dark headers.
const TEXT_START = 238 / ART_W;

const BrandLogo: FC<{ isMobile?: boolean; onDark?: boolean }> = ({ isMobile = false, onDark = false }) => {
  const h = isMobile ? 34 : 46; // visible logo height
  const s = h / BOX.h;
  const img: CSSProperties = {
    position: 'absolute', display: 'block', maxWidth: 'none',
    width: ART_W * s, height: ART_H * s, left: -BOX.x * s, top: -BOX.y * s,
  };
  const pct = `${(TEXT_START * 100).toFixed(2)}%`;
  return (
    <div role="img" aria-label="Wareozo" style={{ position: 'relative', overflow: 'hidden', width: Math.ceil(BOX.w * s), height: h, flexShrink: 0 }}>
      {onDark ? (
        // Dark/green header: mark keeps its colours, the whole wordmark is forced white.
        <>
          <img src={SRC} alt="" aria-hidden style={{ ...img, clipPath: `inset(0 ${(100 - TEXT_START * 100).toFixed(2)}% 0 0)` }} />
          <img src={SRC} alt="" aria-hidden style={{ ...img, clipPath: `inset(0 0 0 ${pct})`, filter: 'brightness(0) invert(1)' }} />
        </>
      ) : (
        <img src={SRC} alt="" aria-hidden style={img} />
      )}
    </div>
  );
};

export default BrandLogo;
